import { render, staticRenderFns } from "./CreatePeriod.vue?vue&type=template&id=509afd0e&scoped=true&"
import script from "./CreatePeriod.vue?vue&type=script&lang=js&"
export * from "./CreatePeriod.vue?vue&type=script&lang=js&"
import style0 from "./CreatePeriod.vue?vue&type=style&index=0&id=509afd0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509afd0e",
  null
  
)

export default component.exports